export default function formatCountdown(msRemaining: number | undefined) {
  if (!msRemaining) return '0:00';
  const totalSeconds = Math.floor(msRemaining / 1000);
  const hours = Math.floor(totalSeconds / 3600);
  const minutes = Math.floor((totalSeconds % 3600) / 60);
  const seconds = totalSeconds % 60;

  const timeInMin = msRemaining ? msRemaining / (1000 * 60) : 0;

  const formattedHours = timeInMin >= 60 ? `${hours}:` : '';

  return `${formattedHours}${String(minutes).padStart(2, '0')}:${String(
    seconds
  ).padStart(2, '0')}`;
}
